// extracted by mini-css-extract-plugin
export default {"toggleButton":"DarkModeToggle_toggleButton__GJpCl","iconContainer":"DarkModeToggle_iconContainer__RFuHs","icon":"DarkModeToggle_icon__xTG4W"};